import { lazy } from 'react';

const CustomUsuari = lazy(() => import('./CustomUsuari'));

export default CustomUsuari;
